module.exports = __webpack_public_path__ + "static/media/aulaDeIngles.efde6769.svg";